import { c as _c } from "react/compiler-runtime";
import { BillingFieldsBaseEnum } from '@sola/schema/dotcom/checkout/billingInfo.ts';
import type { UniqueAddressMap } from '@sola/schema/dotcom/shared/address.ts';
import type { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { useSupporterBillingAddresses } from '@sola/supporter-sdk/hooks/payment-methods.ts';
import { createAddressHash } from '@sola/supporter-sdk/utils/addresses.ts';
import { Skeleton } from '../../atoms/skeleton/skeleton.tsx';
import type { AddressSelectProps } from './address-select.tsx';
import { AddressSelect } from './address-select.tsx';
type AddressSelectSupporterProps = Omit<AddressSelectProps, 'name' | 'addresses' | 'defaultAddress'> & {
  name?: string;
  paymentMethod?: GraphQLSupporterPaymentMethod;
};
export const getCurrentPaymentMethodHash = (addresses?: UniqueAddressMap, paymentMethod?: GraphQLSupporterPaymentMethod) => {
  if (!addresses?.size || !paymentMethod?.billingAddress) {
    return;
  }
  const {
    street,
    city,
    postalCode
  } = paymentMethod.billingAddress;
  if (!street || !city || !postalCode) {
    return;
  }

  // Find matching address by hash
  return createAddressHash(street, city, postalCode);
};
export const AddressSelectSupporter: React.FC<AddressSelectSupporterProps> = t0 => {
  const $ = _c(13);
  let name;
  let paymentMethod;
  let props;
  if ($[0] !== t0) {
    ({
      name,
      paymentMethod,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = name;
    $[2] = paymentMethod;
    $[3] = props;
  } else {
    name = $[1];
    paymentMethod = $[2];
    props = $[3];
  }
  const {
    supporterAddresses,
    isLoading,
    isFetching,
    isPending,
    isError
  } = useSupporterBillingAddresses();
  let t1;
  if ($[4] !== paymentMethod || $[5] !== supporterAddresses) {
    t1 = getCurrentPaymentMethodHash(supporterAddresses, paymentMethod);
    $[4] = paymentMethod;
    $[5] = supporterAddresses;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const defaultAddress = t1;
  if ((isLoading || isFetching || isPending) && !isError) {
    let t2;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Skeleton height={50} />;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  const t2 = name || BillingFieldsBaseEnum.AddressOption;
  let t3;
  if ($[8] !== defaultAddress || $[9] !== props || $[10] !== supporterAddresses || $[11] !== t2) {
    t3 = <AddressSelect {...props} name={t2} defaultAddress={defaultAddress} addresses={supporterAddresses} />;
    $[8] = defaultAddress;
    $[9] = props;
    $[10] = supporterAddresses;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};